import { render } from "./NotificationHistory.vue?vue&type=template&id=9332fc60&scoped=true"
import script from "./NotificationHistory.vue?vue&type=script&lang=js"
export * from "./NotificationHistory.vue?vue&type=script&lang=js"

import "./NotificationHistory.vue?vue&type=style&index=0&id=9332fc60&scoped=true&lang=css"

import exportComponent from "/home/github-runner/actions-runner/_work/acutame/acutame/src/main/front/merchant/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9332fc60"]])

export default __exports__